<template>
    <div class="scenes-box">
        <p class="img-box">
            <img v-if="imgUrl" :src="imgUrl" alt="img" />
            <img v-else :src="$images.material.default" alt="img" />
        </p>
        <div class="title-box">
            <p class="title">
                <span class="name">当前前景：</span>
                <span class="value">{{imgName}}</span>
            </p>
            <div class="btns-box">
                <p
                    v-if="imgUrl"
                    class="btn btn2"
                    @click="handleSetDiplay"
                >{{imgVisible?'隐藏': '显示'}}</p>
                <p
                    class="btn"
                    @click="handleSelectImage"
                >选择前景图</p>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions} from 'vuex'
    import Background from '../background'
    export default {
        name: "ForegroundBox",
        mixins: [Background],
        props: {
            form: Object
        },
        computed: {
            imgUrl() {
                let value = ''
                try {
                    value = this.$store.state.editGameConfig.scenesData.override.foreground
                }catch (e) {
                    console.log('获取图片失败==>', value)
                }
                return value
            },
            imgName() {
                let value = ''
                try {
                    value = this.$store.state.editGameConfig.scenesData.override.foregroundName
                }catch (e) {
                    console.log('获取图片名称失败==>', value)
                }
                return value
            },
            imgVisible() {
                let value = ''
                try {
                    value = this.$store.state.editGameConfig.scenesData.override.foregroundVisible
                }catch (e) {
                    console.log('获取图片名称失败==>', value)
                }
                return value
            }
        },
        watch: {
            form:{
                handler(vl){
                    this.newForm = vl
                },
                deep: true,
                immediate: true
            },
            newForm:{
                handler(vl){
                    this.$emit('update:form',vl)
                },
                deep: true,
                immediate: true
            }
        },
        data () {
            return {
                isShow: true,
                newForm: this.form
            }
        },
        methods: {
            ...mapActions(['setOperationQueue']),
            // 通知cocos侧显示或隐藏
            handleSetDiplay(){
                const foregroundVisible = !(this.$store.state.editGameConfig.scenesData.override && this.$store.state.editGameConfig.scenesData.override.foregroundVisible)
                const operationQueue = [
                    {
                        operation: 'REPLACE',
                        path: '/scenesData/override/foregroundVisible',
                        data: foregroundVisible
                    }
                ]
                this.setOperationQueue(operationQueue)
            },
            // 选中游戏前景景图
            handleSelectImage() {
                this.$toWebMessage({
                    type: 'EditResource',
                    value: {type: "image", value: this.$store.state.editGameConfig.scenesData.categoryId},
                    callback: { type:'EditGameConfig', path: '/scenesData/override', operation: 'REPLACE', flag: 'foreground'}
                })
            }
        }
    }
</script>
